const normalizeClock = value => {
  if (!value) return null
  const text = String(value).trim()
  if (!text) return null
  const match = text.match(/^(\d{1,2}):(\d{2})/)
  if (!match) return null
  return `${String(Number(match[1])).padStart(2, '0')}:${match[2]}`
}

/** UI draft availability (dailyWindow.from / until). */
export const hasCompleteDailyWindowInUiAvailability = (availability = {}) => {
  const daily = availability?.dailyWindow
  if (!daily?.enabled) return false
  return Boolean(normalizeClock(daily.from) && normalizeClock(daily.until))
}

/** Persisted schedule JSON (availability.daily_window). */
export const hasCompleteDailyWindowInApiSchedule = (schedule = {}) => {
  const window = schedule?.availability?.daily_window
  if (!window || window.enabled === false) return false
  return Boolean(normalizeClock(window.start_local) && normalizeClock(window.end_local))
}

export const isEngineDeploySchedule = schedule =>
  Array.isArray(schedule?.deploy?.anchors) && schedule.deploy.anchors.length > 0

export const shouldOmitLegacyExpireFromApi = schedule =>
  isEngineDeploySchedule(schedule) && schedule?.availability != null

export const shouldBackfillDeployTimeOfDay = schedule => {
  if (!schedule?.deploy) return false
  if (isEngineDeploySchedule(schedule)) return false
  if (hasCompleteDailyWindowInApiSchedule(schedule)) return false
  return schedule.deploy.time_of_day == null || schedule.deploy.time_of_day === ''
}

/** Remove stub expire.never left from older scheduling-engine saves. */
export const stripRedundantLegacyExpire = schedule => {
  if (!isEngineDeploySchedule(schedule) || !schedule.availability) return
  const expire = schedule.expire
  if (!expire || typeof expire !== 'object') return
  const keys = Object.keys(expire)
  if (keys.length === 1 && keys[0] === 'never' && expire.never == null) {
    delete schedule.expire
  }
}
